import {Model} from '@vuex-orm/core';
import {TestArea} from '~/models/test/relational/TestArea';
import {TestLicence} from '~/models/test/relational/TestLicence';
import {TestQuestion} from '~/models/test/relational/TestQuestion';
import {TestStudent} from '~/models/test/relational/TestStudent';
import {TestSubArea} from '~/models/test/relational/TestSubArea';
import {TestSubject} from '~/models/test/relational/TestSubject';
import {Question, School, SchoolTest, Student, StudentTestState, TestGroup, TestGroupTest, TestInstance} from '..';

export class Test extends Model {
  static entity = 'tests';

  static fields() {
    return {
      id: this.attr(null),
      title: this.attr(''),
      displayName: this.attr(''),
      type: this.attr(''),
      coolDown: this.attr(null),
      passRate: this.attr(null),
      timeLimit: this.attr(null),
      tries: this.attr(null),
      state: this.attr(null),
      dependentOnId: this.attr(null),
      dependentOn: this.belongsTo(Test, 'dependentOnId'),
      dependants: this.hasMany(Test, 'dependentOnId'),
      questions: this.belongsToMany(Question, TestQuestion, 'testId', 'questionId'),
      licences: this.hasMany(TestLicence, 'testId'),
      subjects: this.hasMany(TestSubject, 'testId'),
      areas: this.hasMany(TestArea, 'testId'),
      subAreas: this.hasMany(TestSubArea, 'testId'),
      instances: this.hasMany(TestInstance, 'testId'),
      students: this.belongsToMany(Student, TestStudent, 'testId', 'studentId'),
      schools: this.belongsToMany(School, SchoolTest, 'testId', 'schoolId'),
      studentTestStates: this.hasMany(StudentTestState, 'testId'),
      testGroups: this.belongsToMany(TestGroup, TestGroupTest, 'testId', 'testGroupId'),

      createdAt: this.attr(''),
      updatedAt: this.attr(''),
    };
  }

  id: number;
  dependentOnId: number;
  title: string;
  displayName: string;
  type: string;
  coolDown: number;
  passRate: number;
  timeLimit: number;
  tries: number;
  state: string;
  dependentOn: Test;
  dependants: Test[];
  questions: Question[];
  licences: TestLicence[];
  instances: TestInstance[];
  subjects: TestSubject[];
  areas: TestArea[];
  subAreas: TestSubArea[];
  testGroups: TestGroup[];

  students: Student[];
  schools: School[];
  studentTestStates: StudentTestState[];

  createdAt: string;
  updatedAt: string;

  get isDefault(): boolean {
    return this.type === 'default';
  }

  get isPreExam(): boolean {
    return this.type === 'preExam';
  }

  get isFinal(): boolean {
    return this.type === 'final';
  }

  get isProgress(): boolean {
    return this.type === 'progress';
  }
}
